<template>
    <div class="main_container">
        <div class="layout_split">

            <RightWing :index="1" :score="score" />

            <div class="main_area">
                <div style="opacity:0; font-size:10px;">space</div>

                <div class="section_title_container">
                    <div class="section_title">{{sectionTitle}}</div>
                    <!-- <div class="article_title" style="background-color:transparent;">팩트체크 하고 싶은 뉴스를 선택하세요</div> -->
                </div>
                <div class="section_title_mobile">{{sectionTitle}}</div>

                <div class="guide_text">팩트체크 하고 싶은 주제를 선택하세요</div>

                <div class="flex_container">
                    <div v-for="(article, index) in articles" :key="index"
                            class="list_item"
                            :class="article.done ? 'list_item_inactive' : 'list_item_active'"
                            @click="touchMenuItem(index)">

                        <div style="text-align:center; width:100%;">
                            {{article.title}}
                        </div>
                    </div>
                </div>
                <div class="btn_container">
                    <div class="btn_other_sections" @click="before">다른 영역 선택하기</div>
                </div>

                <ArticleInfoModal
                    v-if="articleModal"
                    @close_article_info_modal="articleModal=false"
                    :selectedArticleTitle="selectedArticleTitle"
                    :selectedArticleDesc="selectedArticleDesc"
                    :selectedArticleImage="selectedArticleImage"
                    :selectedArticleIndex="selectedArticleIndex" />

            </div>
        </div>
    </div>
</template>

<script>
import RightWing from '../components/RightWingView.vue'
import ArticleInfoModal from '../components/ArticleInfoModal.vue'

export default {
    name: 'ArticleListView',

    components: {
        'RightWing': RightWing,
        'ArticleInfoModal': ArticleInfoModal
    },

    data() {
        return {
            articleModal: false,
            currentPlay: null,
            selectedSectionData: null,
            articles: null,
            sectionTitle: '',
            selectedArticleDesc: null,
            selectedArticleTitle: null,
            selectedArticleIndex: null,
            selectedArticleImage: null,
            score: null,
        }
    },

    mounted() {
        this.currentPlay = this.$getCurrentGame()
        this.selectedSectionData = this.$gameData.sections[this.currentPlay.selectedSection]
        this.articles = this.selectedSectionData.articles
        this.sectionTitle = this.selectedSectionData.title
        this.score = this.currentPlay.score

        // 이미 푼 문제를 disable 시킨다.
        // TODO game data를 수정하기 때문데 더 좋은 방법 필요
        // computed로 그릴 때 체크할까?
        for(let articleData of this.articles) {
            for(let articlePlay of this.currentPlay.articles) {
                if(articleData.title == articlePlay.title) {
                    if(articlePlay.playerResult != undefined) {
                        articleData.done = true
                    }
                }
            }
        }
    },

    methods: {
        touchMenuItem: function(index) {
            let touchedArticle = this.selectedSectionData.articles[index]
            // TODO 위의 방법이 바뀌면 이 방법도 바뀌어야 함
            if(touchedArticle.done == null || touchedArticle.done == false) {
                this.selectedArticleTitle = touchedArticle.title
                this.selectedArticleDesc = touchedArticle.desc
                this.selectedArticleImage = touchedArticle.img
                this.selectedArticleIndex = index
                this.articleModal = true
            }
        },
        before: function() {
            this.$router.push('/sectionList')
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.list_item_active {
    background-color: white;
    box-shadow: 3px 3px 3px grey;
}
.list_item_inactive {
    background-color: gray;
}

/* pc */
@media screen and (min-width: 415px) {
    .list_item {
        display: flex;
        align-items: center;
        width: 900px;
        /* height: 65px; */
        height: 55px;
        margin: 5px auto;
        color:black;
        font-size: 24px;
        cursor:pointer;
    }

    .btn_other_sections {
        text-align: center;
        width: 280px;
        padding: 10px;
        margin: 0px 10px;
        border: 2px solid black;
        font-weight: 700;
        font-size: 26px;
        color: black;
        cursor:pointer;
        background-color: white;
        box-shadow:3px 3px 3px grey;
    }
    .btn_container {
        margin-top: 5px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .guide_text {
        text-align:center;
        font-size:26px;
        font-weight:700;
    }
    .layout_split {
        display:flex;
    }
    .main_area {
        width: 100%;
        background-color:#e5e5e5
    }
    .flex_container {
        text-align:center;
        font-size:26px;
        margin:10px;
        display:flex;
        flex-direction:column;
    }
    .section_title_container {
        display:flex;
        margin-left:20px;
    }
    .section_title_mobile {
        display: none;
    }
}

/* mobile */
@media screen and (max-width: 414px) {
    .layout_split {
        display:flex;
        flex-direction:column;
    }
    .main_area {
        width:100%;
        background-color:#e5e5e5
    }
    .guide_text {
        display: none;
    }    

    .flex_container {
        display:flex;
        flex-direction:column;
    }
    .list_item {
        display: flex;
        align-items: center;
        height: 70px;
        margin: 8px 10px;
        padding: 10px;
        color:black;
        font-size: 18px;
        word-break: keep-all;
    }

    .btn_other_sections {
        text-align: center;
        width: 300px;
        padding: 10px;
        border: 2px solid black;
        font-weight: 700;
        font-size: 24px;
        color: black;
        cursor:pointer;
        background-color: white;
        box-shadow:3px 3px 3px grey;
    }
    .btn_container {
        display: none;
        /* margin: 20px;
        display: flex;
        justify-content: center;
        align-items: center; */
    }
    .section_title_container {
        display: none;
    }
    .section_title_mobile {
        text-align: center;
        color: black;
        font-size: 22px;
        font-weight: 700;
    }
}

</style>
